import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, Injector } from '@angular/core';

import { OVERLAY_PORTAL_DATA, SpinnerOverlayComponent } from './spinner-overlay.component';

@Injectable({
    providedIn: 'root',
})
export class SpinnerOverlayService {
    private overlayRef: OverlayRef;

    constructor(
        private overlay: Overlay,
        private injector: Injector
    ) {}

    public show(showImage: boolean = true) {
        // Returns an OverlayRef (which is a PortalHost)
        if (!this.overlayRef) {
            this.overlayRef = this.overlay.create();
        }

        // Create ComponentPortal that can be attached to a PortalHost
        const spinnerOverlayPortal = new ComponentPortal(SpinnerOverlayComponent, null, this.createInjector(showImage));

        // run in async context for triggering "tick", thus avoid ExpressionChangedAfterItHasBeenCheckedError
        //setTimeout(() => {
        if (this.overlayRef && !this.overlayRef.hasAttached()) {
            this.overlayRef.attach(spinnerOverlayPortal); // Attach ComponentPortal to PortalHost
        }
        //}, 100);
    }

    public hide() {
        if (this.overlayRef) {
            this.overlayRef.detach();
            this.overlayRef.dispose();
        }
        this.overlayRef = undefined;
    }

    private createInjector(data) {
        return Injector.create({
            parent: this.injector,
            providers: [{ provide: OVERLAY_PORTAL_DATA, useValue: data }],
        });
    }
}
